// src/pages/HomePage.jsx (sau unde ai Home-ul)
import React, { useEffect, useState, useRef } from "react";
import "./home.css";
import Header from "../header";
import Footer from "../footer";
import { RiFileExcel2Fill } from "react-icons/ri";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import ResultsPanel from "../components/ResultsPanel";
// import OurProductsSection from "../components/our_products";

const clientId = Date.now().toString();

export default function HomePage() {
  const [fileName, setFileName] = useState("");
  const [results, setMessages] = useState([]);

  const [scrollVisible, setScrollVisible] = useState(false);
  const [text, setText] = useState(""); // cod produs manual
  const [items, setItems] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const [showResults, setShowResults] = useState(false);
  const [progress, setProgress] = useState(0);

  const [cancelToken, setCancelToken] = useState(false);
  const [companyName, setCompanyName] = useState("");

  const eventSourceRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) setScrollVisible(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Cleanup SSE la unmount
  useEffect(() => {
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, []);

  // Cancel SSE + reset UI
  useEffect(() => {
    if (!cancelToken) return;

    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }

    setIsProcessing(false);
    setCancelToken(false);
    setMessages([]);
    setProgress(0);
  }, [cancelToken]);

  const handleUpload = (event) => {
    if (isProcessing) setCancelToken(true);

    setMessages([]);
    setProgress(0);

    const file = event.target.files?.[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const formattedData = jsonData.map((row) => ({
        cod_pnk: row["cod_pnk"] || "No pnk",
      }));

      setItems(formattedData);
    };

    reader.readAsArrayBuffer(file);
  };

  const addSingleCode = () => {
    const code = text.trim();
    if (!code) return;
    setItems([{ cod_pnk: code }]);
    setFileName("");
    setText("");
  };

  const startProcessing = async () => {
    if (!items || items.length === 0) return;

    setMessages([]);
    setProgress(0);
    setIsProcessing(true);
    setShowResults(true);

    // close old SSE
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }

    // 1) POST start
    try {
      const res = await fetch("/api/dev/start-processing", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Accel-Buffering": "no",
          "x-client-id": clientId,
          "x-company-name": companyName || "",
        },
        body: JSON.stringify(items),
      });

      const content = await res.json();
      console.log(content);
    } catch (e) {
      console.error("❌ start-processing error:", e);
      setIsProcessing(false);
      return;
    }

    // 2) SSE stream
    const es = new EventSource(
      `https://marketplace.alzavision.ro/api/dev/stream?clientId=${clientId}`
    );
    eventSourceRef.current = es;

    es.onopen = () => console.log("🟢 SSE conexiune deschisă");

    es.onerror = (err) => {
      console.error("❌ SSE EROARE:", err);
      es.close();
      eventSourceRef.current = null;
      setIsProcessing(false);
    };

    es.addEventListener("end", (event) => {
      console.log("🛑 Stream terminat:", event.data);
      es.close();
      eventSourceRef.current = null;
      setIsProcessing(false);
    });

    es.onmessage = (event) => {
      if (!event.data) return;
      try {
        const parsed = JSON.parse(event.data);

        setMessages((prev) => {
          const newList = [...prev, parsed];
          setProgress(Math.floor((newList.length / items.length) * 100));
          return newList;
        });
      } catch (e) {
        console.error("⚠️ Eroare JSON:", e);
        es.close();
        eventSourceRef.current = null;
        setIsProcessing(false);
      }
    };
  };

  return (
    <React.Fragment>
      <div className="page-container">
        <Header />

        <main className="content">
          <div className="top-content">
            <div className="video-background">
              <video autoPlay loop muted playsInline>
                <source
                  src={require("../assets/videos/3163534-uhd_3840_2160_30fps.mp4")}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>

            <div
              style={{
                zIndex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* CARD PRINCIPAL */}
              <motion.div
                className="center-on-mobile"
                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                whileHover={{
                  scale: 1.02,
                  boxShadow: "0 12px 24px rgba(81, 10, 92, 0.6)",
                }}
                transition={{
                  duration: 0.6,
                  ease: [0.25, 0.8, 0.25, 1],
                }}
                style={{
                  background: "#fff",
                  marginTop: "4rem",
                  padding: "1.5rem",
                  borderRadius: "1rem",
                  boxShadow: "0 10px 20px rgba(81, 10, 92, 0.52)",
                  maxWidth: "520px",
                  width: "min(90vw, 520px)",
                  minHeight: "auto",
                  textAlign: "left",
                  marginTop: "10vw",
                }}
              >
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
                  style={{ margin: 0, fontSize: "1.4rem", color: "#51105C" }}
                >
                  Analizează-ți prețurile pe marketplace-uri
                </motion.h2>

                <p
                  style={{
                    margin: "0.5rem 0 1rem",
                    fontSize: "0.9rem",
                    color: "#555",
                  }}
                >
                  Introdu numele companiei, încarcă fișierul Excel cu coduri de
                  produs și pornește analiza automată a ofertelor.
                </p>

                {/* Company name */}
                <div
                  className="horizontal-container"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.75rem",
                    alignItems: "stretch",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Numele companiei"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    style={{
                      flex: 1,
                      minWidth: "180px",
                      borderRadius: "0.75rem",
                      border: "1px solid #ddd",
                      padding: "0.6rem 0.8rem",
                      fontSize: "0.9rem",
                      outline: "none",
                    }}
                  />
                </div>

                {/* Cod produs + Upload */}
                <div
                  className="horizontal-container"
                  style={{ marginTop: "0.75rem" }}
                >
                  <input
                    type="text"
                    placeholder="Cod de produs"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") addSingleCode();
                    }}
                    style={{
                      flex: 1,
                      minWidth: "180px",
                      borderRadius: "0.75rem",
                      border: "1px solid #ddd",
                      padding: "0.6rem 0.8rem",
                      fontSize: "0.9rem",
                      outline: "none",
                    }}
                  />

                  <div className="upload-container" style={{ flex: 1 }}>
                    <label className="upload-label">
                      <RiFileExcel2Fill className="upload-icon" />
                      <span>{fileName || "Încarcă un fișier Excel"}</span>
                      <input
                        type="file"
                        accept=".xlsx"
                        onChange={handleUpload}
                        className="hidden-input"
                      />
                    </label>
                  </div>
                </div>

                {/* START + progres + toggle rezultate */}
                <div
                  className="vertical-container horizontal-container"
                  style={{ marginTop: "1rem" }}
                >
                  {!isProcessing && (!results || results.length === 0) && (
                    <button
                      className="play-button"
                      onClick={startProcessing}
                      disabled={!items || items.length === 0}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.5rem",
                        padding: "0.5rem 1.2rem",
                        borderRadius: "999px",
                        border: "none",
                        cursor:
                          !items || items.length === 0
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      <svg
                        className="play-icon"
                        viewBox="0 0 24 24"
                        style={{ width: "18px", height: "18px" }}
                      >
                        <path d="M8 5v14l11-7z" fill="currentColor" />
                      </svg>
                      <span>Pornește analiza</span>
                    </button>
                  )}

                  {isProcessing && (
                    <div>
                      <div className="progress-container">
                        <p style={{ marginBottom: "0.5rem" }}>
                          Procesate {results.length} din {items.length} (
                          {progress}%)
                        </p>
                      </div>
                      <div className="horizontal-container">
                        <div className="dot-loader">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  )}

                  {results.length > 0 && (
                    <span
                      className="show-more"
                      onClick={() => setShowResults((v) => !v)}
                      style={{ marginTop: "0.75rem", cursor: "pointer" }}
                    >
                      {showResults
                        ? "Ascunde rezultatele"
                        : "Afișează rezultatele"}
                    </span>
                  )}
                </div>
              </motion.div>

              {/* PANEL REZULTATE (sub card) */}
              <ResultsPanel
                show={showResults && results.length > 0}
                onClose={() => setShowResults(false)}
                results={results}
                companyName={companyName}
              />
            </div>
          </div>

          {/* Alte secțiuni */}
          {/* <OurProductsSection /> */}
        </main>

        <Footer />
      </div>
    </React.Fragment>
  );
}
